import { Component } from '@angular/core';
import { Auth, authState, sendEmailVerification } from '@angular/fire/auth';
import { pluck } from 'rxjs/operators';

@Component({
    selector: 'is-confirm-email',
    templateUrl: './confirm-email.component.html',
    styleUrls: ['./confirm-email.component.scss'],
    standalone: false
})
export class ConfirmEmailComponent {
  myEmail$ = authState(this.auth).pipe(
    pluck('email')
  )

  resendStatus: 'unsent' | 'sending' | 'sent' | 'error' = 'unsent'

  constructor(
    public auth: Auth,
  ) {}

  async resendEmailVerification() {
    this.resendStatus = 'sending'
    try {
      await sendEmailVerification(this.auth.currentUser)
      this.resendStatus = 'sent'
    } catch {
      this.resendStatus = 'error'
    }
  }
}
